<div class="w-full px-4 sm:px-6 lg:px-8 pt-1 sm:pt-2 md:pt-3 bg-white">
  <app-breadcrum [data]="breadcrumbData"></app-breadcrum>
</div>

<!-- Mobile View (below md) -->
<div class="md:hidden w-full px-4 mt-2 inline-flex flex-col justify-start items-start gap-1">
  <div class="justify-start text-black text-xl mt-2 font-bold leading-7">
    Buyer Terms & Conditions
  </div>
  <div class="self-stretch flex flex-col justify-start items-start">
    <!-- Intro Mobile -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('intro')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Neutrals-Black text-lg font-bold leading-normal">
            Introduction
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('intro')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('intro')">
        <div class="text-xs font-semibold text-gray-500">
          Last updated on: __
        </div>
        <div class="self-stretch justify-start text-black text-sm font-medium leading-tight">
          These Terms and Conditions (“Terms”) govern access or use by you (“Buyer”, “you”, “your”) of the Platform
          (defined below) provided by Tata Motors Limited (“Tata Motors”, “we”, “us”), a company established under the
          laws of India, having its registered office at 24, Bombay House, Homi Mody Street, Mumbai – 400 001. Please
          read these Terms carefully before accessing or using the Platform and/or Services. These Terms also include
          our privacy policy, available at [insert link] (“Privacy Policy”) and any other additional policies and terms
          issued by Tata Motors from time to time.
        </div>
        <div class="self-stretch justify-start text-black text-sm font-medium leading-tight">
          Your access and use of the Platform and the Services constitute your agreement to be bound by these Terms,
          which establishes a contractual relationship between you and Tata Motors. If you do not agree to these Terms,
          you may not access or use the Services or the Platform.
        </div>
        <div class="self-stretch justify-start text-black text-sm font-medium leading-tight">
          For further clarity, this document is an electronic record in terms of the Information Technology Act, 2000,
          (“IT Act”) and the amendments thereof from time to time and the rules thereunder as applicable, and the
          amended provisions pertaining to electronic records in various statutes as amended by the IT Act. This
          electronic record is generated by a computer system and does not require any physical or digital signatures.
        </div>
      </div>
    </div>

    <!-- Section 1 Mobile: Definitions -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('definitions')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            1. Definitions
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('definitions')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('definitions')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.1.</strong> “Affiliate(s)” shall mean group companies, affiliates, associates, and/or subsidiaries
          of Tata Motors.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.2.</strong> “Platform” means the digital marketplace made available by Tata Motors at [insert link]
          and/or mobile application, enabling Sellers to list and Buyers to purchase Products from Sellers.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.3.</strong> “Services” shall have the same meaning as ascribed to it under Clause 3 of these Terms.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.4.</strong> “Product(s)” means the end-of-life vehicle automotive parts, components, Scrap
          Materials, refurbished products, or other goods made available for purchase on the Platform.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.5.</strong> “Seller” means any seller authorised by us including but limited to Registered Vehicle
          Scrapping Facility (RVSF) under the Motor Vehicles (Registration and Functions of Vehicle Scrapping Facility)
          Rules, 2021, recycler, refurbisher or such authorised business that lists and offers Products for sale on the
          Platform.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.6.</strong> “Scrap Materials” means recyclable, dismantled, end-of-life, waste, or non-functional
          materials and components made available on the Platform, including but not limited to metal scrap, polymer and
          rubber materials, electronic and electrical waste, batteries and related components, catalytic converter
          materials, foam materials, and used automotive oil.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.7.</strong> “Buyer(s)” means any individual or entity, including but not limited to fleet owners,
          garage owners, mechanics, retailers, recyclers, refurbishers, or other registered users on the Platform, who
          purchase or seek to purchase Products listed by Sellers.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>1.8.</strong> “Third Party Services” shall have the same meaning as ascribed to it under Clause 3.2
          hereunder.
        </p>
      </div>
    </div>

    <!-- Section 2 Mobile: Eligibility -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('eligibility')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            2. Eligibility
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('eligibility')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('eligibility')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>2.1.</strong> By accepting these Terms, you represent and warrant that (a) you have full legal
          capacity, right and authority to agree to and be bound by these Terms, (b) you are at least 18 (Eighteen)
          years of age or older, (c) you have not been previously suspended, removed or disqualified by Tata Motors or
          any of its Affiliates from availing the Platform and/or Services, (d) you are not barred or otherwise legally
          prohibited from accessing or using the Platform and/or Services, and (e) you are not and will not impersonate
          any person, entity or falsely state or otherwise misrepresent such person’s or entity’s identity. A person who
          is not competent to contract a minor, a person of unsound mind, etc., may not access this Platform and use the
          Services without the consent of his or her guardian. The guardian is presumed to have read these Terms to give
          consent on behalf of a minor and shall be bound by these Terms. If at any time, Tata Motors is of the opinion
          that you do not satisfy the eligibility criteria, including but not limited to any misrepresentation, misuse
          of any Service or offers, fraudulent or suspicious activities, Tata Motors retains all rights to disable your
          access and/or suspend your use of the Platform and/or Services with immediate effect.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>2.2.</strong> If you represent an entity, organisation, or any other legal person, not being a natural
          person, you confirm and represent that you are duly authorised by the organisation, the entity, the legal
          person, or management of such organisation, entity, or a legal person to accept these Terms, have the
          necessary power and authority to bind such entity, organisation, or legal person to these Terms.
        </p>
      </div>
    </div>

    <!-- Section 3 Mobile: Scope of Services -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('services')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            3. Scope of Services
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('services')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('services')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>3.1.</strong> The Platform allows Sellers to list and sell Products to Buyers and facilitates
          transactions by enabling Buyers to browse Product listings, place orders with Sellers, make payments, and
          access order tracking and customer support. (“Services”).
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>3.2.</strong> The Services may include services, content, documents, and information owned by,
          licensed to, or otherwise made available by a third party or our Affiliates (“Third Party Services”), and may
          also include links to the Third-Party Services. You understand and acknowledge that Third Party Services are
          the responsibility of the respective third-party or Affiliate that renders such Third Party Services. You
          further acknowledge that your use of such Third-Party Services is solely at your own risk.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>3.3.</strong> You hereby agree and acknowledge that at any point of time we, or a Third Party Service
          provider or our Affiliates providing any of the Services on the Platform, shall have the right to reject any
          of your requests for availing any of the Services provided on the Platform at our, the Third Party Service
          provider’s or our Affiliate’s sole discretion without assigning any reason to you whatsoever, unless otherwise
          required under applicable law.
        </p>
      </div>
    </div>

    <!-- Section 4 Mobile: Account Creation -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('account')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            4. Account Creation
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('account')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('account')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.1.</strong> To avail the Services, you are required to register yourself and create an account on
          the Platform (“Account”). In addition to setting up a username to create an Account, you will be required to
          furnish certain information, including but not limited to phone numbers and other personal information. You
          agree to provide and maintain true, accurate, and complete information about yourself as prompted on the
          Platform, and failure to do so shall constitute a breach of the Terms, which may result in immediate
          termination or suspension of your Account.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.2.</strong> You are solely responsible for maintaining the confidentiality of the Account details
          and for any activity that occurs through your Account. You agree to immediately notify Tata Motors of any
          actual or suspected unauthorised use of your Account or any other breach of security. Tata Motors will not be
          liable for any losses or damages that may arise from your failure to comply with the above-mentioned
          provisions or your failure to ensure the confidentiality of your Account or password.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.3.</strong> You agree and acknowledge that you may be required to provide us with access to certain
          information and documents, including vehicle registration numbers to enable us to provide the Platform and/or
          Services. Where this information includes personal information, our access to and use of such information
          shall be in accordance with the Privacy Policy. You may have the right to revoke access to your data; however,
          you acknowledge that this may impair your use of the Platform and/or Services.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.4.</strong> You may be required to provide certain certifications or other supporting documents in
          order to purchase the Products. You agree to provide accurate, complete and valid documentation. Failure to do
          so shall constitute breach of the Terms, which may result in refusal of the Services, suspension or immediate
          termination of your Account, at our sole discretion.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.5.</strong> Any indication by the Sellers that the Products correspond to a certain grade or level
          shall be subject to the disclaimers set out in Clause 10 of these Terms and Conditions.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>4.6.</strong> You agree and understand that Tata Motors reserves the right to disable your access to
          the Account if, in our reasonable opinion, you are in breach of any provision of the Terms or the applicable
          law or in the event of any actual or suspected unauthorised access to your Account.
        </p>
      </div>
    </div>

    <!-- Section 5 Mobile: Intellectual Property -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer" (click)="toggleSection('ip')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            5. Intellectual Property
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('ip')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('ip')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>5.1.</strong> All rights, title, and interest in and to the Platform and/or Services, including all
          intellectual property rights arising out of the Platform and/or Services, are owned by or otherwise licensed
          to us. Subject to compliance with these Terms, we grant you a non-exclusive, non-transferable, non-sub
          licensable, royalty-free, revocable, and limited licence in India to access and use the Platform and Services
          to purchase Products in accordance with these Terms and instructions issued by us from time to time.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>5.2.</strong> We may request you to submit suggestions and other feedback, including bug reports,
          relating to the Platform and/or Services from time to time (“Feedback”). We may freely use, copy, disclose,
          publish, display, distribute, and exploit the Feedback we receive from you, without any payment of royalty,
          acknowledgement, prior consent, or any other form of restriction arising out of your intellectual property
          rights in such Feedback.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>5.3.</strong> Except as stated in these Terms, nothing in these Terms should be construed as
          conferring any right in or licence to our or any third-party’s intellectual property rights.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>5.4.</strong> Any infringement, violation or misappropriation of our intellectual property by you that
          is likely to have an adverse impact on our brand, standing or reputation shall result in immediate termination
          or suspension of your right to Platform and/or Services as determined by us in our sole discretion.
        </p>
      </div>
    </div>

    <!-- Section 6 Mobile: General Responsibility -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('responsibility')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            6. General Responsibility
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('responsibility')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('responsibility')">
        <div class="text-black text-sm font-medium leading-tight">
          <p class="mb-2"><strong>6.1.</strong> You represent and warrant that:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li> all information that you provide on the Platform or in relation to the Services or through the Account
              or any additional information you provide is complete, true, and correct on the date of agreeing to these
              Terms and shall continue to be complete, true, and correct while you avail the Services, access the
              Platform or otherwise have an Account on the Platform. Should any information that you provide change
              during the existence of these Terms, you undertake to immediately bring such change to our notice. We do
              not accept any responsibility or liability for any loss or damage that you may suffer or incur if any
              information, documentation, material, or data provided to avail the Services is incorrect, incomplete,
              inaccurate, or misleading, or if you fail to disclose any material fact or notify us of any change to the
              same.</li>
            <li> your use and access of the Platform and/or the Services shall not violate any applicable law.</li>
            <li> you do not and will not impersonate any person or entity, or falsely state or otherwise misrepresent
              such person’s or entity’s identity.</li>
          </ul>
        </div>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>6.2.</strong> You shall extend all cooperation to us in our defence of any proceedings that may be
          initiated against us due to breach of your obligations or covenants under these Terms.
        </p>
        <div class="text-black text-sm font-medium leading-tight">
          <p class="mb-2"><strong>6.3.</strong> You shall not use the Platform and/or Services in any manner except as
            expressly permitted in these Terms and in accordance with applicable law. Without limiting the generality of
            the preceding sentence, you may not:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li> infringe, violate or misappropriate any proprietary rights, including but not limited to copyrights,
              patents, trademarks, or trade secrets, of Tata Motors or any other party;</li>
            <li> except as may be provided hereunder, sell, lease, sublicence, copy, display, market, distribute,
              modify, publish, reproduce, store, transmit, post, translate, create any derivative works from, or licence
              the Platform and/or the Services;</li>
            <li> use the Platform and/or Services to transmit any data or send or upload any material that contains
              viruses, trojan horses, worms, timebombs, keystroke loggers, spyware, adware, or any other harmful
              programmes or similar computer code designed to adversely affect the operation of any computer software or
              hardware;</li>
            <li> use any robot, spider, other automated device, or manual process to monitor or copy the Platform and/or
              or Services or any portion thereof;</li>
            <li> engage in the systematic retrieval of content from the Platform to create or compile, directly or
              indirectly, a collection, compilation, database or directory;</li>
            <li> use the Platform and/or Services in any unlawful manner, for fraudulent or malicious activities, or in
              any manner inconsistent with these Terms;</li>
            <li> violate applicable laws in any manner;</li>
            <li> reverse engineer, decompile or disassemble any third party’s intellectual property, or otherwise
              attempt to obtain, directly or indirectly, source code or attempt to discover any underlying proprietary
              methods or algorithms;</li>
            <li> upload or transmit any information or content that is obscene, pornographic, paedophilic, immoral,
              invasive of another’s privacy, or is relating to or encouraging money laundering or gambling, an online
              game that causes user harm, or promoting enmity between different groups on the grounds of religion or
              caste with the intent to incite violence;</li>
            <li> act in an abusive or threatening manner or use abusive or threatening language on or through the
              Platform;</li>
            <li> upload or transmit information or content that is harmful to children or that impersonates another
              person, or deceive or mislead any addressee about the origin of a message, or knowingly and intentionally
              communicates any misinformation or information which is patently false and untrue or misleading in nature;
            </li>
            <li> upload or transmit information or content that threatens the unity, integrity, defence, security, or
              sovereignty of any nation, friendly relations with foreign states, or public order, or cause incitement to
              the commission of any cognizable offence, or prevent investigation of any offence, or insult any nation in
              any manner; and</li>
            <li> take any action that may adversely affect the Platform and/or Services.</li>
          </ul>
        </div>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>6.4.</strong> You irrevocably and unconditionally agree that any contract entered into through or
          facilitated by the Platform, in violation of the Terms, shall be void and any delivery or payment made in
          furtherance thereof shall be deemed to be invalid.
        </p>
      </div>
    </div>

    <!-- Section 7 Mobile: Returns, Refunds and Cancellations -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('returns')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            7. Returns, Refunds and Cancellations
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('returns')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('returns')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>7.1.</strong> Returns, refunds, and cancellations shall be governed by the return, refund and
          cancellation policy available at [insert link] on the Platform and updated from time to time.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>7.2.</strong> You shall cooperate with Tata Motors, its payment partners, the Sellers and any
          third-party logistics providers in the resolution of returns, replacements, or cancellations.
        </p>
      </div>
    </div>

    <!-- Section 8 Mobile: Payments -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('payments')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            8. Payments
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('payments')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('payments')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>8.1.</strong> Payments for Products purchased on the Platform may be made through third-party payment
          processors we have partnered with.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>8.2.</strong> Tata Motors shall not be responsible for the actual processing of payments by the
          payment partners.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>8.3.</strong> The processing of payments is subject to additional terms and conditions of the
          third-party payment processors. Tata Motors shall not be liable for any errors by the third-party payment
          processors. In the event of any unsuccessful payments, the money so debited shall be credited in accordance
          with the additional terms and conditions of such third-party payment processors.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>8.4.</strong> Tata Motors shall not be liable for any loss, dispute, or discrepancy arising from cash
          payments made to delivery personnel.
        </p>
      </div>
    </div>

    <!-- Section 9 Mobile: Term and Termination -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('termination')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            9. Term and Termination
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('termination')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('termination')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>9.1.</strong> These Terms shall remain in effect unless terminated in accordance with the terms
          hereunder.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>9.2.</strong> We may terminate your access or use of the Platform and/or Services, or any portion
          thereof, immediately and at any point, at our sole discretion, if you violate the Terms or the Privacy Policy
          or when you cease to become a user of our Platform and/or Services.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>9.3.</strong> Your access to the Platform and/or Services may also be terminated further to any
          requests by authorised law enforcement and/or other government and regulatory agencies and authorities.
        </p>
        <div class="text-black text-sm font-medium leading-tight">
          <p class="mb-2"><strong>9.4.</strong> Upon termination of these Terms:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li> all rights and licences granted to you under these Terms shall immediately cease;</li>
            <li> you shall immediately stop using the Platform and Services; and</li>
            <li> Tata Motors may delete or disable access to your Account.</li>
          </ul>
        </div>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>9.5.</strong> The termination of these Terms shall not affect any rights or obligations which have
          accrued prior to termination or any provision which is intended to survive termination.
        </p>
      </div>
    </div>

    <!-- Section 10 Mobile: Disclaimers -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('disclaimers')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            10. Disclaimers
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('disclaimers')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('disclaimers')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.1.</strong> You acknowledge that Tata Motors operates the Platform as a technology service provider
          and does not take title to, own, manufacture, stock, or control the Products listed by Sellers and shall not
          assume any obligations or liabilities in respect thereof.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.2.</strong> Use of the Platform and Services is at your sole risk. You hereby accept full
          responsibility for any consequences that may arise from your use of Platform or Services, and expressly agree
          and acknowledge that Tata Motors shall have no liability with respect to the same.
        </p>
        <div class="text-black text-sm font-medium leading-tight">
          <p class="mb-2"><strong>10.3.</strong> The Platform and the Services are provided by us on an “as is” basis
            without warranty of any kind, express, implied, statutory or otherwise, including the implied warranties of
            title, non-infringement, merchantability, or fitness for a particular purpose. Without limiting the
            foregoing, we make no warranty or representation that:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li> the Platform or the Services will meet your requirements or expectations, or</li>
            <li> that your use of the Platform or the Services will be uninterrupted, timely, secure, or error-free;
            </li>
            <li> any errors or defects in the Platform will be corrected; and/or</li>
            <li> the Platform is free of viruses or harmful components.</li>
          </ul>
        </div>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.4.</strong> You acknowledge that transactions conducted through the Platform are at your own risk,
          and we shall not be responsible for any acts or omissions of Sellers.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.5.</strong> We do not make any representations or warranties regarding the quality, safety,
          legality, authenticity, accuracy, merchantability, fitness for a particular purpose, or condition of any
          Product listed on the Platform. All warranties, if any, are provided solely by the respective Seller.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.6.</strong> Product descriptions, specifications, pricing, availability, and images are provided by
          Sellers. The images of products displayed on the Platform are for representative purposes only and may not be
          identical to the products they are intended to represent. The actual products may vary from the images
          displayed on the Platform, including in terms of colour, appearance, packaging, dimensions and other features.
          We shall not be responsible for inaccuracies or omissions in any information on the Platform, including in the
          Product descriptions, specifications, pricing, availability, or images displayed on the Platform.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.7.</strong> Payments made through the Platform are processed through third-party payment service
          providers. We are not responsible for payment failures, unauthorised transactions, delays, or errors
          attributable to such service providers.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.8.</strong> Delivery, shipping, and logistics services may be provided by Sellers or third-party
          service providers and may be subject to an additional fee. We shall not be liable for delays, loss, or damage
          occurring during shipment.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.9.</strong> Buyers are responsible for ensuring that their purchase, possession, and use of
          Products comply with applicable laws and regulations. Notwithstanding any indication on the Platform that
          certain Products are compatible with particular automobiles, we do not guarantee that the Products are
          suitable for use in any particular jurisdiction or purpose.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>10.10.</strong> We make no representations and disclaim all warranties and liabilities arising out of
          or pertaining to Third-Party Services, including their accuracy or completeness. Should you avail any
          Third-Party Service, you shall be governed and bound by the additional terms and conditions of the applicable
          third party or the Affiliate providing the Third-Party Service.
        </p>
      </div>
    </div>

    <!-- Section 11 Mobile: Indemnity -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('indemnity')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            11. Indemnity
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('indemnity')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('indemnity')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>11.1.</strong> You shall indemnify, defend or settle at our option, and hold us, our partners, parent
          companies, subsidiaries, and their officers, associates successors, assigns, licensors, employees, directors,
          agents, and representatives, harmless from and against any claim, demand, lawsuits, judicial proceeding,
          losses, liabilities, damages and costs (including, without limitation, from all damages, liabilities,
          settlements, costs and attorneys’ fees) due to or arising out arising from or relating to:
        </p>
        <ul class="list-disc ml-6 space-y-1 text-black text-sm font-medium leading-tight">
          <li> acts, commissions or omissions, errors, misrepresentations, misconduct, negligence, fraud, forgery,
            dishonesty, violation attributable to you and/or your personnel/agents/representatives, or any third party
            who may use your Account;</li>
          <li> your access to the Platform and/or the Services;</li>
          <li> your use of the Platform and/or the Services in violation of these Terms;</li>
          <li> contravention of any applicable law;</li>
          <li> any claim from any governmental authority;</li>
          <li> any third party as a result of any action or inaction on your part, including but not limited to
            infringement of intellectual property rights;</li>
          <li> unauthorised use of your Account as a result of your failure in keeping the account information secure,
            absolute, correct and confidential; and</li>
          <li> any breach or violation of these Terms.</li>
        </ul>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>11.2.</strong> For the avoidance of doubt, it is clarified that the right to indemnification in
          connection with any of the aforesaid causes of action is independent and in addition to other rights and
          remedies as may be available to us at law or in equity.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>11.3.</strong> It is further clarified that the rights and obligations under this Clause shall survive
          your cessation of the use of the Platform and/or the Services.
        </p>
      </div>
    </div>

    <!-- Section 12 Mobile: Limitation of Liability -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('liability')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            12. Limitation of Liability
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('liability')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('liability')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>12.1.</strong> To the extent permitted by applicable laws, in no event shall Tata Motors, our
          partners, subsidiaries, Affiliates, officers, employees, directors, agents, contractors, suppliers, or
          licensors be liable to you or any third party for any special, indirect, incidental, consequential, punitive,
          reliance, or exemplary (including without limitation lost business opportunities, loss of profits (including
          anticipated profits) or any other pecuniary or non-pecuniary losses including but not limited to breach or
          loss of data, or goodwill, regardless of whether we have been advised of the possibility of such damages, or
          based on any theory of liability, including breach of contract or warranty, negligence or other tortious
          action.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>12.2.</strong> Notwithstanding any provision to the contrary, Tata Motors’ maximum aggregate liability
          to you under the Terms or otherwise for any loss in connection with the Platform or a Service shall be limited
          to [_].
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>12.3.</strong> This Clause sets forth the entire liability of Tata Motors and your exclusive remedy
          with respect to the Platform and/or Services.
        </p>
      </div>
    </div>

    <!-- Section 13 Mobile: Jurisdiction, Governing Laws, and Dispute Resolution -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('jurisdiction')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            13. Jurisdiction, Governing Laws, and Dispute Resolution
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('jurisdiction')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('jurisdiction')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>13.1.</strong> These Terms shall be governed by and construed and enforced in accordance with the laws
          of India. Subject to other provisions in this Clause, courts in Mumbai shall have exclusive jurisdiction over
          all issues arising out of these Terms or the use of the Services.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>13.2.</strong> Any controversies, conflicts, disputes, or differences arising out of these Terms shall
          be resolved by arbitration in accordance with the Arbitration and Conciliation Act, 1996, for the time being
          in force, which is deemed to be incorporated by reference in this Clause. The tribunal shall consist of 1
          (one) arbitrator appointed by us. The seat and venue of the arbitration shall be Mumbai, and the language of
          the arbitration shall be English.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>13.3.</strong> The parties to the arbitration shall keep the arbitration confidential and not disclose
          to any person, other than on a need-to-know basis or to legal advisors, unless required to do so by law. The
          decision of the arbitrator shall be final and binding on all the parties hereto.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>13.4.</strong> Each party to the arbitration shall bear its own costs with respect to any dispute.
        </p>
      </div>
    </div>

    <!-- Section 14 Mobile: Miscellaneous -->
    <div class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3">
      <div class="self-stretch inline-flex justify-between items-center cursor-pointer"
        (click)="toggleSection('miscellaneous')">
        <div class="flex-1 flex justify-start items-center gap-2">
          <div class="flex-1 justify-start text-Text-Black text-lg font-bold leading-normal">
            14. Miscellaneous
          </div>
        </div>
        <div data-icon="Chevron-up" class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
          [class.rotate-180]="!isSectionOpen('miscellaneous')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9" stroke="black"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <div class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
        [class.hidden]="!isSectionOpen('miscellaneous')">
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.1. Severability:</strong> If any provision of these Terms is determined by any court or other
          competent authority to be unlawful or unenforceable, the other provisions of these Terms will continue to be
          in effect. If any unlawful or unenforceable provision would be lawful or enforceable if part of it were
          deleted, that part will be deemed to be deleted, and the rest of the provision will continue to be in effect
          (unless that would contradict the clear intention of the clause, in which case the entirety of the relevant
          provision will be deemed to be deleted).
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.2. Assignment:</strong> You shall not licence, sell, transfer or assign your rights, obligations,
          or covenants under these Terms in any manner without our prior written consent. We may grant or withhold this
          consent in our sole discretion and subject to any conditions deemed appropriate. We may assign our rights to
          any of its Affiliates, subsidiaries, or parent companies, or to any successor in interest of any business
          associated with the Platform and/or Services, without any prior notice to you.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.3. Notices:</strong> All notices, requests, demands, and determinations for us under these Terms
          (other than routine operational communications) shall be sent to __.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.4. Third Party Rights:</strong> No third party shall have any rights to enforce any Terms contained
          herein.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.5. Force Majeure:</strong> You agree that we shall not be liable for any breach of these Terms if
          such breach is caused by an event that is unforeseeable and beyond our reasonable control (such as, depending
          on the circumstances, unavailability of any communication system, breach or virus in our system, sabotage,
          fire, flood, explosion, acts of God, civil commotion, strikes or industrial action of any kind, riots,
          insurrection, war, acts of government, unauthorised access to computer data and storage devices, computer
          crashes and regulatory or government actions (“Force Majeure Event”). In such circumstances, we will be
          entitled to a reasonable extension of time to perform our obligations and shall take commercially reasonable
          methods to inform you of the Force Majeure Event and use all reasonable endeavours to mitigate the effects of
          the Force Majeure Event.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.6. Correspondences:</strong> We shall send all communications to you by text messages, electronic
          mails, WhatsApp messages, push notifications and/or via other progressive technology in connection with your
          access to the Platform, utilisation of the Services and as part of our promotional and marketing strategy. You
          agree to receive all messages, emails and/or WhatsApp messages including transactional messages, from us,
          Sellers, any third parties and our Affiliates. You authorise us, our Affiliates and other entities providing
          Third Party Services to override the DND settings to reach out to you over calls, SMS, emails, WhatsApp
          messages and any other mode of communication. We may use Third Party Service providers to send alerts or to
          communicate with you. To the extent permissible under applicable law, you agree that all documents, notices,
          disclosures and other communications that we provide to you electronically satisfy any legal requirement that
          such communication be in writing. You further acknowledge that you are responsible for the contact details
          shared with us and shall update us on any change to your contact details.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.7. Regulatory Changes:</strong> You acknowledge and agree that we may have to modify the Platform
          and/or Services to comply with the applicable laws. As a result of this, you may be unable to access or use
          all or any part of the Platform and/or Services. We shall not be liable to you for such inability to use the
          Platform and/or Services pursuant to our compliance with the applicable laws.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.8. Changes to the Terms and the Platform:</strong> We reserve the right at any time to modify these
          Terms as well as modify the Platform and/or Services at any time. Such modifications and additional terms and
          conditions will be effective immediately. We reserve the right to suspend or withdraw or restrict the
          availability of all or any part of the Platform and/or Services for business and operational reasons. Tata
          Motors shall not be liable for any consequences resulting from such modification, suspension, withdrawal or
          discontinuation, except as may be required under applicable laws.
        </p>
        <p class="text-black text-sm font-medium leading-tight">
          <strong>14.9. Relationship between Parties:</strong> The relationship between Tata Motors and you is on a
          principal to principal basis. Nothing in these Terms shall be deemed to constitute any person a partner, joint
          venture agent or legal representative of any other, or to create any fiduciary, employer-employee relationship
          between any such persons.
        </p>
        <div class="text-black text-sm font-medium leading-tight">
          <p class="font-bold mb-1">14.10. Grievance Redressal</p>
          <p class="mb-2">
            In order to address any questions or grievances that you may have regarding the use of the Platform and/or
            Services, please contact our grievance officer:
          </p>
          <p><strong>Name:</strong> __</p>
          <p><strong>Address:</strong> __</p>
          <p><strong>Email Address:</strong> __</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Desktop & Tablet View (md and above) -->
<div class="hidden md:flex w-full px-4 sm:px-6 lg:px-8 mt-2 md:mt-4 gap-8 h-[calc(100vh-7.5rem)] overflow-hidden">
  <!-- Sidebar (Fixed) -->
  <nav class="w-1/4 h-full overflow-y-auto pr-4 shrink-0 terms-scrollbar">
    <ul class="space-y-4 text-gray-500 font-medium">
      <li (click)="scrollToSection('intro')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'intro'"
        [class.font-bold]="activeSection === 'intro'">
        Introduction
      </li>
      <li (click)="scrollToSection('definitions')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'definitions'"
        [class.font-bold]="activeSection === 'definitions'">
        1. Definitions
      </li>
      <li (click)="scrollToSection('eligibility')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'eligibility'"
        [class.font-bold]="activeSection === 'eligibility'">
        2. Eligibility
      </li>
      <li (click)="scrollToSection('services')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'services'"
        [class.font-bold]="activeSection === 'services'">
        3. Scope of Services
      </li>
      <li (click)="scrollToSection('account')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'account'"
        [class.font-bold]="activeSection === 'account'">
        4. Account Creation
      </li>
      <li (click)="scrollToSection('ip')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'ip'"
        [class.font-bold]="activeSection === 'ip'">
        5. Intellectual Property
      </li>
      <li (click)="scrollToSection('responsibility')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'responsibility'"
        [class.font-bold]="activeSection === 'responsibility'">
        6. General Responsibility
      </li>
      <li (click)="scrollToSection('returns')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'returns'"
        [class.font-bold]="activeSection === 'returns'">
        7. Returns & Refunds
      </li>
      <li (click)="scrollToSection('payments')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'payments'"
        [class.font-bold]="activeSection === 'payments'">
        8. Payments
      </li>
      <li (click)="scrollToSection('termination')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'termination'"
        [class.font-bold]="activeSection === 'termination'">
        9. Term & Termination
      </li>
      <li (click)="scrollToSection('disclaimers')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'disclaimers'"
        [class.font-bold]="activeSection === 'disclaimers'">
        10. Disclaimers
      </li>
      <li (click)="scrollToSection('indemnity')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'indemnity'"
        [class.font-bold]="activeSection === 'indemnity'">
        11. Indemnity
      </li>
      <li (click)="scrollToSection('liability')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'liability'"
        [class.font-bold]="activeSection === 'liability'">
        12. Limitation of Liability
      </li>
      <li (click)="scrollToSection('jurisdiction')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'jurisdiction'"
        [class.font-bold]="activeSection === 'jurisdiction'">
        13. Dispute Resolution
      </li>
      <li (click)="scrollToSection('miscellaneous')"
        class="cursor-pointer text-base transition-colors hover:text-blue-600"
        [class.text-blue-600]="activeSection === 'miscellaneous'"
        [class.font-bold]="activeSection === 'miscellaneous'">
        14. Miscellaneous
      </li>
    </ul>
  </nav>

  <!-- Main content (Scrollable) -->
  <div #contentContainer id="terms-content-container" (scroll)="onContentScroll($event)"
    class="w-3/4 h-full min-w-0 px-2 sm:px-6 overflow-y-auto text-gray-800 scroll-smooth terms-scrollbar">
    <!-- Introduction Section -->
    <section #introSection id="intro" class="scroll-mt-4 pt-2 pb-6">
      <h1 class="text-3xl font-bold mb-3 text-black">Terms & Conditions</h1>
      <h2 class="text-xl font-bold mb-1 text-gray-900">BUYER TERMS AND CONDITIONS</h2>
      <p class="text-sm font-semibold text-gray-500 mb-4">Last updated on: __</p>
      <p class="mb-3 text-sm leading-relaxed">
        These Terms and Conditions (“Terms”) govern access or use by you (“Buyer”, “you”, “your”) of the Platform
        (defined below) provided by Tata Motors Limited (“Tata Motors”, “we”, “us”), a company established under the
        laws of India, having its registered office at 24, Bombay House, Homi Mody Street, Mumbai – 400 001. Please read
        these Terms carefully before accessing or using the Platform and/or Services. These Terms also include our
        privacy policy, available at [insert link] (“Privacy Policy”) and any other additional policies and terms issued
        by Tata Motors from time to time.
      </p>
      <p class="mb-3 text-sm leading-relaxed">
        Your access and use of the Platform and the Services constitute your agreement to be bound by these Terms, which
        establishes a contractual relationship between you and Tata Motors. If you do not agree to these Terms, you may
        not access or use the Services or the Platform.
      </p>
      <p class="text-sm leading-relaxed">
        For further clarity, this document is an electronic record in terms of the Information Technology Act, 2000,
        (“IT Act”) and the amendments thereof from time to time and the rules thereunder as applicable, and the amended
        provisions pertaining to electronic records in various statutes as amended by the IT Act. This electronic record
        is generated by a computer system and does not require any physical or digital signatures.
      </p>
    </section>

    <!-- Section 1: Definitions -->
    <section #definitionsSection id="definitions" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">1. DEFINITIONS</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>1.1.</strong> “Affiliate(s)” shall mean group companies, affiliates, associates, and/or subsidiaries
          of Tata Motors.
        </p>
        <p>
          <strong>1.2.</strong> “Platform” means the digital marketplace made available by Tata Motors at [insert link]
          and/or mobile application, enabling Sellers to list and Buyers to purchase Products from Sellers.
        </p>
        <p>
          <strong>1.3.</strong> “Services” shall have the same meaning as ascribed to it under Clause 3 of these Terms.
        </p>
        <p>
          <strong>1.4.</strong> “Product(s)” means the end-of-life vehicle automotive parts, components, Scrap
          Materials, refurbished products, or other goods made available for purchase on the Platform.
        </p>
        <p>
          <strong>1.5.</strong> “Seller” means any seller authorised by us including but limited to Registered Vehicle
          Scrapping Facility (RVSF) under the Motor Vehicles (Registration and Functions of Vehicle Scrapping Facility)
          Rules, 2021, recycler, refurbisher or such authorised business that lists and offers Products for sale on the
          Platform.
        </p>
        <p>
          <strong>1.6.</strong> “Scrap Materials” means recyclable, dismantled, end-of-life, waste, or non-functional
          materials and components made available on the Platform, including but not limited to metal scrap, polymer and
          rubber materials, electronic and electrical waste, batteries and related components, catalytic converter
          materials, foam materials, and used automotive oil.
        </p>
        <p>
          <strong>1.7.</strong> “Buyer(s)” means any individual or entity, including but not limited to fleet owners,
          garage owners, mechanics, retailers, recyclers, refurbishers, or other registered users on the Platform, who
          purchase or seek to purchase Products listed by Sellers.
        </p>
        <p>
          <strong>1.8.</strong> “Third Party Services” shall have the same meaning as ascribed to it under Clause 3.2
          hereunder.
        </p>
      </div>
    </section>

    <!-- Section 2: Eligibility -->
    <section #eligibilitySection id="eligibility" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">2. ELIGIBILITY</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>2.1.</strong> By accepting these Terms, you represent and warrant that (a) you have full legal
          capacity, right and authority to agree to and be bound by these Terms, (b) you are at least 18 (Eighteen)
          years of age or older, (c) you have not been previously suspended, removed or disqualified by Tata Motors or
          any of its Affiliates from availing the Platform and/or Services, (d) you are not barred or otherwise legally
          prohibited from accessing or using the Platform and/or Services, and (e) you are not and will not impersonate
          any person, entity or falsely state or otherwise misrepresent such person’s or entity’s identity. A person who
          is not competent to contract a minor, a person of unsound mind, etc., may not access this Platform and use the
          Services without the consent of his or her guardian. The guardian is presumed to have read these Terms to give
          consent on behalf of a minor and shall be bound by these Terms. If at any time, Tata Motors is of the opinion
          that you do not satisfy the eligibility criteria, including but not limited to any misrepresentation, misuse
          of any Service or offers, fraudulent or suspicious activities, Tata Motors retains all rights to disable your
          access and/or suspend your use of the Platform and/or Services with immediate effect.
        </p>
        <p>
          <strong>2.2.</strong> If you represent an entity, organisation, or any other legal person, not being a natural
          person, you confirm and represent that you are duly authorised by the organisation, the entity, the legal
          person, or management of such organisation, entity, or a legal person to accept these Terms, have the
          necessary power and authority to bind such entity, organisation, or legal person to these Terms.
        </p>
      </div>
    </section>

    <!-- Section 3: Scope of Services -->
    <section #servicesSection id="services" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">3. SCOPE OF SERVICES</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>3.1.</strong> The Platform allows Sellers to list and sell Products to Buyers and facilitates
          transactions by enabling Buyers to browse Product listings, place orders with Sellers, make payments, and
          access order tracking and customer support. (“Services”).
        </p>
        <p>
          <strong>3.2.</strong> The Services may include services, content, documents, and information owned by,
          licensed to, or otherwise made available by a third party or our Affiliates (“Third Party Services”), and may
          also include links to the Third-Party Services. You understand and acknowledge that Third Party Services are
          the responsibility of the respective third-party or Affiliate that renders such Third Party Services. You
          further acknowledge that your use of such Third-Party Services is solely at your own risk.
        </p>
        <p>
          <strong>3.3.</strong> You hereby agree and acknowledge that at any point of time we, or a Third Party Service
          provider or our Affiliates providing any of the Services on the Platform, shall have the right to reject any
          of your requests for availing any of the Services provided on the Platform at our, the Third Party Service
          provider’s or our Affiliate’s sole discretion without assigning any reason to you whatsoever, unless otherwise
          required under applicable law.
        </p>
      </div>
    </section>

    <!-- Section 4: Account Creation -->
    <section #accountSection id="account" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">4. ACCOUNT CREATION</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>4.1.</strong> To avail the Services, you are required to register yourself and create an account on
          the Platform (“Account”). In addition to setting up a username to create an Account, you will be required to
          furnish certain information, including but not limited to phone numbers and other personal information. You
          agree to provide and maintain true, accurate, and complete information about yourself as prompted on the
          Platform, and failure to do so shall constitute a breach of the Terms, which may result in immediate
          termination or suspension of your Account.
        </p>
        <p>
          <strong>4.2.</strong> You are solely responsible for maintaining the confidentiality of the Account details
          and for any activity that occurs through your Account. You agree to immediately notify Tata Motors of any
          actual or suspected unauthorised use of your Account or any other breach of security. Tata Motors will not be
          liable for any losses or damages that may arise from your failure to comply with the above-mentioned
          provisions or your failure to ensure the confidentiality of your Account or password.
        </p>
        <p>
          <strong>4.3.</strong> You agree and acknowledge that you may be required to provide us with access to certain
          information and documents, including vehicle registration numbers to enable us to provide the Platform and/or
          Services. Where this information includes personal information, our access to and use of such information
          shall be in accordance with the Privacy Policy. You may have the right to revoke access to your data; however,
          you acknowledge that this may impair your use of the Platform and/or Services.
        </p>
        <p>
          <strong>4.4.</strong> You may be required to provide certain certifications or other supporting documents in
          order to purchase the Products. You agree to provide accurate, complete and valid documentation. Failure to do
          so shall constitute breach of the Terms, which may result in refusal of the Services, suspension or immediate
          termination of your Account, at our sole discretion.
        </p>
        <p>
          <strong>4.5.</strong> Any indication by the Sellers that the Products correspond to a certain grade or level
          shall be subject to the disclaimers set out in Clause 10 of these Terms and Conditions.
        </p>
        <p>
          <strong>4.6.</strong> You agree and understand that Tata Motors reserves the right to disable your access to
          the Account if, in our reasonable opinion, you are in breach of any provision of the Terms or the applicable
          law or in the event of any actual or suspected unauthorised access to your Account.
        </p>
      </div>
    </section>

    <!-- Section 5: Intellectual Property -->
    <section #ipSection id="ip" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">5. INTELLECTUAL PROPERTY</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>5.1.</strong> All rights, title, and interest in and to the Platform and/or Services, including all
          intellectual property rights arising out of the Platform and/or Services, are owned by or otherwise licensed
          to us. Subject to compliance with these Terms, we grant you a non-exclusive, non-transferable, non-sub
          licensable, royalty-free, revocable, and limited licence in India to access and use the Platform and Services
          to purchase Products in accordance with these Terms and instructions issued by us from time to time.
        </p>
        <p>
          <strong>5.2.</strong> We may request you to submit suggestions and other feedback, including bug reports,
          relating to the Platform and/or Services from time to time (“Feedback”). We may freely use, copy, disclose,
          publish, display, distribute, and exploit the Feedback we receive from you, without any payment of royalty,
          acknowledgement, prior consent, or any other form of restriction arising out of your intellectual property
          rights in such Feedback.
        </p>
        <p>
          <strong>5.3.</strong> Except as stated in these Terms, nothing in these Terms should be construed as
          conferring any right in or licence to our or any third-party’s intellectual property rights.
        </p>
        <p>
          <strong>5.4.</strong> Any infringement, violation or misappropriation of our intellectual property by you that
          is likely to have an adverse impact on our brand, standing or reputation shall result in immediate termination
          or suspension of your right to Platform and/or Services as determined by us in our sole discretion.
        </p>
      </div>
    </section>

    <!-- Section 6: General Responsibility -->
    <section #responsibilitySection id="responsibility" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">6. GENERAL RESPONSIBILITY</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <div>
          <p class="mb-2"><strong>6.1.</strong> You represent and warrant that:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li>all information that you provide on the Platform or in relation to the Services or through the
              Account or any additional information you provide is complete, true, and correct on the date of agreeing
              to these Terms and shall continue to be complete, true, and correct while you avail the Services, access
              the Platform or otherwise have an Account on the Platform. Should any information that you provide change
              during the existence of these Terms, you undertake to immediately bring such change to our notice. We do
              not accept any responsibility or liability for any loss or damage that you may suffer or incur if any
              information, documentation, material, or data provided to avail the Services is incorrect, incomplete,
              inaccurate, or misleading, or if you fail to disclose any material fact or notify us of any change to the
              same.</li>
            <li>your use and access of the Platform and/or the Services shall not violate any applicable law.</li>
            <li>you do not and will not impersonate any person or entity, or falsely state or otherwise misrepresent
              such person’s or entity’s identity.</li>
          </ul>
        </div>
        <p>
          <strong>6.2.</strong> You shall extend all cooperation to us in our defence of any proceedings that may be
          initiated against us due to breach of your obligations or covenants under these Terms.
        </p>
        <div>
          <p class="mb-2"><strong>6.3.</strong> You shall not use the Platform and/or Services in any manner except as
            expressly permitted in these Terms and in accordance with applicable law. Without limiting the generality of
            the preceding sentence, you may not:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li>infringe, violate or misappropriate any proprietary rights, including but not limited to copyrights,
              patents, trademarks, or trade secrets, of Tata Motors or any other party;</li>
            <li>except as may be provided hereunder, sell, lease, sublicence, copy, display, market, distribute,
              modify, publish, reproduce, store, transmit, post, translate, create any derivative works from, or licence
              the Platform and/or the Services;</li>
            <li>use the Platform and/or Services to transmit any data or send or upload any material that contains
              viruses, trojan horses, worms, timebombs, keystroke loggers, spyware, adware, or any other harmful
              programmes or similar computer code designed to adversely affect the operation of any computer software or
              hardware;</li>
            <li>use any robot, spider, other automated device, or manual process to monitor or copy the Platform
              and/or or Services or any portion thereof;</li>
            <li>engage in the systematic retrieval of content from the Platform to create or compile, directly or
              indirectly, a collection, compilation, database or directory;</li>
            <li>use the Platform and/or Services in any unlawful manner, for fraudulent or malicious activities, or
              in any manner inconsistent with these Terms;</li>
            <li>violate applicable laws in any manner;</li>
            <li>reverse engineer, decompile or disassemble any third party’s intellectual property, or otherwise
              attempt to obtain, directly or indirectly, source code or attempt to discover any underlying proprietary
              methods or algorithms;</li>
            <li>upload or transmit any information or content that is obscene, pornographic, paedophilic, immoral,
              invasive of another’s privacy, or is relating to or encouraging money laundering or gambling, an online
              game that causes user harm, or promoting enmity between different groups on the grounds of religion or
              caste with the intent to incite violence;</li>
            <li>act in an abusive or threatening manner or use abusive or threatening language on or through the
              Platform;</li>
            <li>upload or transmit information or content that is harmful to children or that impersonates another
              person, or deceive or mislead any addressee about the origin of a message, or knowingly and intentionally
              communicates any misinformation or information which is patently false and untrue or misleading in nature;
            </li>
            <li>upload or transmit information or content that threatens the unity, integrity, defence, security, or
              sovereignty of any nation, friendly relations with foreign states, or public order, or cause incitement to
              the commission of any cognizable offence, or prevent investigation of any offence, or insult any nation in
              any manner; and</li>
            <li>take any action that may adversely affect the Platform and/or Services.</li>
          </ul>
        </div>
        <p>
          <strong>6.4.</strong> You irrevocably and unconditionally agree that any contract entered into through or
          facilitated by the Platform, in violation of the Terms, shall be void and any delivery or payment made in
          furtherance thereof shall be deemed to be invalid.
        </p>
      </div>
    </section>

    <!-- Section 7: Returns, Refunds and Cancellations -->
    <section #returnsSection id="returns" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">7. RETURNS, REFUNDS AND CANCELLATIONS</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>7.1.</strong> Returns, refunds, and cancellations shall be governed by the return, refund and
          cancellation policy available at [insert link] on the Platform and updated from time to time.
        </p>
        <p>
          <strong>7.2.</strong> You shall cooperate with Tata Motors, its payment partners, the Sellers and any
          third-party logistics providers in the resolution of returns, replacements, or cancellations.
        </p>
      </div>
    </section>

    <!-- Section 8: Payments -->
    <section #paymentsSection id="payments" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">8. PAYMENTS</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>8.1.</strong> Payments for Products purchased on the Platform may be made through third-party payment
          processors we have partnered with.
        </p>
        <p>
          <strong>8.2.</strong> Tata Motors shall not be responsible for the actual processing of payments by the
          payment partners.
        </p>
        <p>
          <strong>8.3.</strong> The processing of payments is subject to additional terms and conditions of the
          third-party payment processors. Tata Motors shall not be liable for any errors by the third-party payment
          processors. In the event of any unsuccessful payments, the money so debited shall be credited in accordance
          with the additional terms and conditions of such third-party payment processors.
        </p>
        <p>
          <strong>8.4.</strong> Tata Motors shall not be liable for any loss, dispute, or discrepancy arising from cash
          payments made to delivery personnel.
        </p>
      </div>
    </section>

    <!-- Section 9: Term and Termination -->
    <section #terminationSection id="termination" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">9. TERM AND TERMINATION</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>9.1.</strong> These Terms shall remain in effect unless terminated in accordance with the terms
          hereunder.
        </p>
        <p>
          <strong>9.2.</strong> We may terminate your access or use of the Platform and/or Services, or any portion
          thereof, immediately and at any point, at our sole discretion, if you violate the Terms or the Privacy Policy
          or when you cease to become a user of our Platform and/or Services.
        </p>
        <p>
          <strong>9.3.</strong> Your access to the Platform and/or Services may also be terminated further to any
          requests by authorised law enforcement and/or other government and regulatory agencies and authorities.
        </p>
        <div>
          <p class="mb-2"><strong>9.4.</strong> Upon termination of these Terms:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li>all rights and licences granted to you under these Terms shall immediately cease;</li>
            <li>you shall immediately stop using the Platform and Services; and</li>
            <li>Tata Motors may delete or disable access to your Account.</li>
          </ul>
        </div>
        <p>
          <strong>9.5.</strong> The termination of these Terms shall not affect any rights or obligations which have
          accrued prior to termination or any provision which is intended to survive termination.
        </p>
      </div>
    </section>

    <!-- Section 10: Disclaimers -->
    <section #disclaimersSection id="disclaimers" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">10. DISCLAIMERS</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>10.1.</strong> You acknowledge that Tata Motors operates the Platform as a technology service provider
          and does not take title to, own, manufacture, stock, or control the Products listed by Sellers and shall not
          assume any obligations or liabilities in respect thereof.
        </p>
        <p>
          <strong>10.2.</strong> Use of the Platform and Services is at your sole risk. You hereby accept full
          responsibility for any consequences that may arise from your use of Platform or Services, and expressly agree
          and acknowledge that Tata Motors shall have no liability with respect to the same.
        </p>
        <div>
          <p class="mb-2"><strong>10.3.</strong> The Platform and the Services are provided by us on an “as is” basis
            without warranty of any kind, express, implied, statutory or otherwise, including the implied warranties of
            title, non-infringement, merchantability, or fitness for a particular purpose. Without limiting the
            foregoing, we make no warranty or representation that:</p>
          <ul class="list-disc ml-6 space-y-1">
            <li>the Platform or the Services will meet your requirements or expectations, or</li>
            <li>that your use of the Platform or the Services will be uninterrupted, timely, secure, or error-free;
            </li>
            <li>any errors or defects in the Platform will be corrected; and/or</li>
            <li>the Platform is free of viruses or harmful components.</li>
          </ul>
        </div>
        <p>
          <strong>10.4.</strong> You acknowledge that transactions conducted through the Platform are at your own risk,
          and we shall not be responsible for any acts or omissions of Sellers.
        </p>
        <p>
          <strong>10.5.</strong> We do not make any representations or warranties regarding the quality, safety,
          legality, authenticity, accuracy, merchantability, fitness for a particular purpose, or condition of any
          Product listed on the Platform. All warranties, if any, are provided solely by the respective Seller.
        </p>
        <p>
          <strong>10.6.</strong> Product descriptions, specifications, pricing, availability, and images are provided by
          Sellers. The images of products displayed on the Platform are for representative purposes only and may not be
          identical to the products they are intended to represent. The actual products may vary from the images
          displayed on the Platform, including in terms of colour, appearance, packaging, dimensions and other features.
          We shall not be responsible for inaccuracies or omissions in any information on the Platform, including in the
          Product descriptions, specifications, pricing, availability, or images displayed on the Platform.
        </p>
        <p>
          <strong>10.7.</strong> Payments made through the Platform are processed through third-party payment service
          providers. We are not responsible for payment failures, unauthorised transactions, delays, or errors
          attributable to such service providers.
        </p>
        <p>
          <strong>10.8.</strong> Delivery, shipping, and logistics services may be provided by Sellers or third-party
          service providers and may be subject to an additional fee. We shall not be liable for delays, loss, or damage
          occurring during shipment.
        </p>
        <p>
          <strong>10.9.</strong> Buyers are responsible for ensuring that their purchase, possession, and use of
          Products comply with applicable laws and regulations. Notwithstanding any indication on the Platform that
          certain Products are compatible with particular automobiles, we do not guarantee that the Products are
          suitable for use in any particular jurisdiction or purpose.
        </p>
        <p>
          <strong>10.10.</strong> We make no representations and disclaim all warranties and liabilities arising out of
          or pertaining to Third-Party Services, including their accuracy or completeness. Should you avail any
          Third-Party Service, you shall be governed and bound by the additional terms and conditions of the applicable
          third party or the Affiliate providing the Third-Party Service.
        </p>
      </div>
    </section>

    <!-- Section 11: Indemnity -->
    <section #indemnitySection id="indemnity" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">11. INDEMNITY</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>11.1.</strong> You shall indemnify, defend or settle at our option, and hold us, our partners, parent
          companies, subsidiaries, and their officers, associates successors, assigns, licensors, employees, directors,
          agents, and representatives, harmless from and against any claim, demand, lawsuits, judicial proceeding,
          losses, liabilities, damages and costs (including, without limitation, from all damages, liabilities,
          settlements, costs and attorneys’ fees) due to or arising out arising from or relating to:
        </p>
        <ul class="list-disc ml-6 space-y-1">
          <li>acts, commissions or omissions, errors, misrepresentations, misconduct, negligence, fraud, forgery,
            dishonesty, violation attributable to you and/or your personnel/agents/representatives, or any third party
            who may use your Account;</li>
          <li>your access to the Platform and/or the Services;</li>
          <li>your use of the Platform and/or the Services in violation of these Terms;</li>
          <li>contravention of any applicable law;</li>
          <li>any claim from any governmental authority;</li>
          <li>any third party as a result of any action or inaction on your part, including but not limited to
            infringement of intellectual property rights;</li>
          <li>unauthorised use of your Account as a result of your failure in keeping the account information
            secure, absolute, correct and confidential; and</li>
          <li>any breach or violation of these Terms.</li>
        </ul>
        <p>
          <strong>11.2.</strong> For the avoidance of doubt, it is clarified that the right to indemnification in
          connection with any of the aforesaid causes of action is independent and in addition to other rights and
          remedies as may be available to us at law or in equity.
        </p>
        <p>
          <strong>11.3.</strong> It is further clarified that the rights and obligations under this Clause shall survive
          your cessation of the use of the Platform and/or the Services.
        </p>
      </div>
    </section>

    <!-- Section 12: Limitation of Liability -->
    <section #liabilitySection id="liability" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">12. LIMITATION OF LIABILITY</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>12.1.</strong> To the extent permitted by applicable laws, in no event shall Tata Motors, our
          partners, subsidiaries, Affiliates, officers, employees, directors, agents, contractors, suppliers, or
          licensors be liable to you or any third party for any special, indirect, incidental, consequential, punitive,
          reliance, or exemplary (including without limitation lost business opportunities, loss of profits (including
          anticipated profits) or any other pecuniary or non-pecuniary losses including but not limited to breach or
          loss of data, or goodwill, regardless of whether we have been advised of the possibility of such damages, or
          based on any theory of liability, including breach of contract or warranty, negligence or other tortious
          action.
        </p>
        <p>
          <strong>12.2.</strong> Notwithstanding any provision to the contrary, Tata Motors’ maximum aggregate liability
          to you under the Terms or otherwise for any loss in connection with the Platform or a Service shall be limited
          to [_].
        </p>
        <p>
          <strong>12.3.</strong> This Clause sets forth the entire liability of Tata Motors and your exclusive remedy
          with respect to the Platform and/or Services.
        </p>
      </div>
    </section>

    <!-- Section 13: Jurisdiction, Governing Laws, and Dispute Resolution -->
    <section #jurisdictionSection id="jurisdiction" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">13. JURISDICTION, GOVERNING LAWS, AND DISPUTE RESOLUTION</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>13.1.</strong> These Terms shall be governed by and construed and enforced in accordance with the laws
          of India. Subject to other provisions in this Clause, courts in Mumbai shall have exclusive jurisdiction over
          all issues arising out of these Terms or the use of the Services.
        </p>
        <p>
          <strong>13.2.</strong> Any controversies, conflicts, disputes, or differences arising out of these Terms shall
          be resolved by arbitration in accordance with the Arbitration and Conciliation Act, 1996, for the time being
          in force, which is deemed to be incorporated by reference in this Clause. The tribunal shall consist of 1
          (one) arbitrator appointed by us. The seat and venue of the arbitration shall be Mumbai, and the language of
          the arbitration shall be English.
        </p>
        <p>
          <strong>13.3.</strong> The parties to the arbitration shall keep the arbitration confidential and not disclose
          to any person, other than on a need-to-know basis or to legal advisors, unless required to do so by law. The
          decision of the arbitrator shall be final and binding on all the parties hereto.
        </p>
        <p>
          <strong>13.4.</strong> Each party to the arbitration shall bear its own costs with respect to any dispute.
        </p>
      </div>
    </section>

    <!-- Section 14: Miscellaneous -->
    <section #miscellaneousSection id="miscellaneous" class="scroll-mt-4 pt-5 pb-5 border-t border-gray-100">
      <h2 class="text-2xl font-bold mb-4 text-black">14. MISCELLANEOUS</h2>
      <div class="space-y-3 text-sm leading-relaxed">
        <p>
          <strong>14.1. Severability:</strong> If any provision of these Terms is determined by any court or other
          competent authority to be unlawful or unenforceable, the other provisions of these Terms will continue to be
          in effect. If any unlawful or unenforceable provision would be lawful or enforceable if part of it were
          deleted, that part will be deemed to be deleted, and the rest of the provision will continue to be in effect
          (unless that would contradict the clear intention of the clause, in which case the entirety of the relevant
          provision will be deemed to be deleted).
        </p>
        <p>
          <strong>14.2. Assignment:</strong> You shall not licence, sell, transfer or assign your rights, obligations,
          or covenants under these Terms in any manner without our prior written consent. We may grant or withhold this
          consent in our sole discretion and subject to any conditions deemed appropriate. We may assign our rights to
          any of its Affiliates, subsidiaries, or parent companies, or to any successor in interest of any business
          associated with the Platform and/or Services, without any prior notice to you.
        </p>
        <p>
          <strong>14.3. Notices:</strong> All notices, requests, demands, and determinations for us under these Terms
          (other than routine operational communications) shall be sent to __.
        </p>
        <p>
          <strong>14.4. Third Party Rights:</strong> No third party shall have any rights to enforce any Terms contained
          herein.
        </p>
        <p>
          <strong>14.5. Force Majeure:</strong> You agree that we shall not be liable for any breach of these Terms if
          such breach is caused by an event that is unforeseeable and beyond our reasonable control (such as, depending
          on the circumstances, unavailability of any communication system, breach or virus in our system, sabotage,
          fire, flood, explosion, acts of God, civil commotion, strikes or industrial action of any kind, riots,
          insurrection, war, acts of government, unauthorised access to computer data and storage devices, computer
          crashes and regulatory or government actions (“Force Majeure Event”). In such circumstances, we will be
          entitled to a reasonable extension of time to perform our obligations and shall take commercially reasonable
          methods to inform you of the Force Majeure Event and use all reasonable endeavours to mitigate the effects of
          the Force Majeure Event.
        </p>
        <p>
          <strong>14.6. Correspondences:</strong> We shall send all communications to you by text messages, electronic
          mails, WhatsApp messages, push notifications and/or via other progressive technology in connection with your
          access to the Platform, utilisation of the Services and as part of our promotional and marketing strategy. You
          agree to receive all messages, emails and/or WhatsApp messages including transactional messages, from us,
          Sellers, any third parties and our Affiliates. You authorise us, our Affiliates and other entities providing
          Third Party Services to override the DND settings to reach out to you over calls, SMS, emails, WhatsApp
          messages and any other mode of communication. We may use Third Party Service providers to send alerts or to
          communicate with you. To the extent permissible under applicable law, you agree that all documents, notices,
          disclosures and other communications that we provide to you electronically satisfy any legal requirement that
          such communication be in writing. You further acknowledge that you are responsible for the contact details
          shared with us and shall update us on any change to your contact details.
        </p>
        <p>
          <strong>14.7. Regulatory Changes:</strong> You acknowledge and agree that we may have to modify the Platform
          and/or Services to comply with the applicable laws. As a result of this, you may be unable to access or use
          all or any part of the Platform and/or Services. We shall not be liable to you for such inability to use the
          Platform and/or Services pursuant to our compliance with the applicable laws.
        </p>
        <p>
          <strong>14.8. Changes to the Terms and the Platform:</strong> We reserve the right at any time to modify these
          Terms as well as modify the Platform and/or Services at any time. Such modifications and additional terms and
          conditions will be effective immediately. We reserve the right to suspend or withdraw or restrict the
          availability of all or any part of the Platform and/or Services for business and operational reasons. Tata
          Motors shall not be liable for any consequences resulting from such modification, suspension, withdrawal or
          discontinuation, except as may be required under applicable laws.
        </p>
        <p>
          <strong>14.9. Relationship between Parties:</strong> The relationship between Tata Motors and you is on a
          principal to principal basis. Nothing in these Terms shall be deemed to constitute any person a partner, joint
          venture agent or legal representative of any other, or to create any fiduciary, employer-employee relationship
          between any such persons.
        </p>
        <div class="mt-4 p-4 bg-gray-50 rounded border border-gray-200">
          <h3 class="font-bold text-base mb-2 text-black">14.10. Grievance Redressal</h3>
          <p class="mb-3 text-sm">
            In order to address any questions or grievances that you may have regarding the use of the Platform and/or
            Services, please contact our grievance officer:
          </p>
          <div class="space-y-1 text-sm">
            <p><strong>Name:</strong> __</p>
            <p><strong>Address:</strong> __</p>
            <p><strong>Email Address:</strong> __</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>